import { CapoPlugin } from "/home/forge/efxpp.ch/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];